import { render } from "./AddProduct.vue?vue&type=template&id=e5742312&scoped=true&ts=true"
import script from "./AddProduct.vue?vue&type=script&lang=ts"
export * from "./AddProduct.vue?vue&type=script&lang=ts"

import "./AddProduct.vue?vue&type=style&index=0&id=e5742312&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5742312"]])

export default __exports__